module.exports = __webpack_public_path__ + "static/imuno-natura-logo-9a96968cca9bb6abc32c7bdef8160913.svg";